import { useContext } from "react";
import { Button } from "../../components/button/Button";
import { FeatureContext } from "../../Context";
import { getDescendantProp, lang, useBfGlobals } from "../../Utils";
import { Item } from "./components/Item";
import Section from "./components/Section";
import SubSection from "./components/SubSection";
import { BsKey } from 'react-icons/bs';

const MyAccount = () => {
  const context = useContext(FeatureContext);
  const globals = useBfGlobals();

  const getValue = (field) => getDescendantProp(context.user?.data, field);

  return (<div className="bf-dashboard-panel">

    <Section title={lang("Account Details")}>
      <SubSection title={lang("Customer Portal Information")}>
        <Item label={lang('Email')} value={getValue('email')} />
        <Item label={' '} value={true}>
          <Button onClick={() => window.open(globals.get('links.reset_password'), '_blank')}>
            <BsKey /><span>{lang('Reset Password')}</span>
          </Button>
        </Item>
      </SubSection>
      <SubSection title={lang("Contact Information")}>
        <Item label={lang('Firstname')} value={getValue('name')} />
        <Item label={lang('Lastname')} value={getValue('surname')} />
        <Item label={lang('Company')} value={getValue('company.company')} />
        <Item label={lang('Telephone')} value={getValue('telephone')} />
      </SubSection>
      <SubSection title={lang("Address information")}>
        <Item label={lang('Invoice address')} value={getValue('company.invoiceAddress')} />
        <Item label={lang('Postal Code')} value={getValue('company.postalCode')} />
        <Item label={lang('City')} value={getValue('company.city')} />
        <Item label={lang('Country')} value={getValue('company.country')} />
      </SubSection>
    </Section>
  </div >)
}

export default MyAccount;